export class SelfDirectingContact {
  firstName?: string;

  lastName?: string;

  relationship?: string;

  phoneNumber?: string;

  invalidPhoneNumber?: boolean;

  phoneType?: string;

  infoOnFile?: boolean;

  isEmpty: boolean;

  createdAt?: number;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.firstName = obj?.firstName;
    this.lastName = obj?.lastName;
    this.relationship = obj?.relationship;
    this.phoneNumber = obj?.phoneNumber;
    this.invalidPhoneNumber = obj?.invalidPhoneNumber;
    this.phoneType = obj?.phoneType;
    this.infoOnFile = obj?.infoOnFile;
    this.isEmpty = Object.keys(obj || {}).length === 0;
    this.createdAt = obj?.createdAt;
  }
}

export default SelfDirectingContact;
